import {googleLogout, useGoogleLogin} from '@react-oauth/google';
import {Button} from 'platform/components';
import {Center} from 'platform/foundation';

import {use} from 'react';

import {useNavigate} from 'shared/web';

import {browserStorageKey} from '../../constants/browserStorageKey';
import {UserContext} from '../../utils/UserContext';

export function LoginPage() {
  const navigate = useNavigate();
  const [_token, setToken] = use(UserContext);

  const logout = () => {
    sessionStorage.removeItem(browserStorageKey.ACCESS_TOKEN);
    setToken(null);
    googleLogout();
    navigate('/login');
  };

  const login = useGoogleLogin({
    onError: logout,
    onNonOAuthError: logout,
    onSuccess: (tokenResponse) => {
      if (!tokenResponse || !tokenResponse.access_token) {
        return logout();
      }
      sessionStorage.setItem(browserStorageKey.ACCESS_TOKEN, tokenResponse.access_token);
      setToken(tokenResponse.access_token);
      navigate('/');
    },
  });

  return (
    <Center>
      <Button title="Sign in with Google" variant="secondary" onClick={() => login()} />
    </Center>
  );
}
